'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axiosInterceptorsLoader = require('./axios-interceptors-loader');

var _axiosInterceptorsLoader2 = _interopRequireDefault(_axiosInterceptorsLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _defaults = {
  loadInterceptors: true
};

exports.default = function (axios, _ref) {
  var baseURL = _ref.baseURL,
      _ref$loadInterceptors = _ref.loadInterceptors,
      loadInterceptors = _ref$loadInterceptors === undefined ? _defaults.loadInterceptors : _ref$loadInterceptors;

  axios.defaults.baseURL = baseURL;

  return _axiosInterceptorsLoader2.default.loadIfNeeded(axios, loadInterceptors);
};
//# sourceMappingURL=wix-axios-config.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-axios-config/dist/src/wix-axios-config.js
// module id = 792
// module chunks = 0